import 'swiper/css/bundle';

(async function initSwiperSlider() {
    "use strict";

    // Select target elements
    const thumbsEl = document.querySelector("#ts2-thumbs");
    const mainEl = document.querySelector("#ts-2");

    // Guard clause: Ensure main slider exists before loading dependencies or initializing
    if (!mainEl) return;

    try {
        // Dynamically import Swiper and modules
        const { default: Swiper, Autoplay, Thumbs } = await import('swiper/bundle');

        let tSwiper = null;

        // Initialize thumbnail swiper if container exists
        if (thumbsEl) {
            tSwiper = new Swiper(thumbsEl, {
                spaceBetween: 0,
                slidesPerView: 10,
                freeMode: true,
                watchSlidesProgress: true,
            });
        }

        // Initialize main swiper
        const swiper = new Swiper(mainEl, {
            modules: [Autoplay, Thumbs],
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            loop: true,
            centeredSlides: true,
            spaceBetween: 0,
            slidesPerView: 1,
            thumbs: {
                swiper: tSwiper,
            },
        });
    } catch (error) {
        console.error("Failed to load or initialize Swiper:", error);
    }
})();